import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

import { rootRoute as baseRoute } from '@/tenant/root'

export const rootRoute = createRoute({
    getParentRoute: () => baseRoute,
    path: '/applications',
    component: lazyRouteComponent(() => import('./Root'), 'Root'),
    loader: async ({ parentMatchPromise }) => {
        await parentMatchPromise
    },
    beforeLoad: async ({ location }): Promise<void> => {
        const [, tenantShortId, , subpath] = location.pathname.split('/')

        if (!subpath) {
            throw redirect({
                replace: true,
                to: '/$tenantShortId/applications/list',
                params: {
                    tenantShortId,
                },
            })
        }
    },
})
